import { Search } from 'lucide-react'

import { Input } from '@/view/components/ui/input'
import { Spinner } from '@/view/components/ui/spinner'
import { BasicTable } from '@/view/components/BasicTable'
import { SupportRequest } from '@/app/entities/SupportRequest'

import { useSupportRequests } from './useSupportRequests'
import { SupportRequestFilter } from './components/SupportRequestFilter'
import { SupportRequestDetailsSheet } from './components/SupportRequestDetailsSheet'
import { MobileSupportRequestList } from './components/MobileSupportRequestList'
import { Button } from '@/view/components/ui/button'
import { SupportRequestButton } from '@/view/components/SupportRequestButton'

export default function SupportRequests() {
  const {
    pageTitle,
    isStaffView,

    table,
    supportRequests,
    isLoading,
    isFetching,
    isFetchingNextPage,
    observerRef,
    shouldShowInfiniteScroll,

    searchValue,
    handleSearchInputChange,

    statusOptions,
    selectedStatusOptions,
    handleSelectStatus,

    reasonOptions,
    selectedReasonOptions,
    handleSelectReason,

    handleClearFilters,

    selectedNumber,
    isDetailsModalOpen,
    openDetails,
    closeDetails,

    isClaimingNext,
    claimNextSupportRequest,
  } = useSupportRequests()

  return (
    <div className="min-h-[calc(100vh-100px)]">
      <h1 className="text-2xl font-semibold">{pageTitle}</h1>
      <p className="my-5 font-medium text-black04">
        {isStaffView
          ? 'Acompanhe e gerencie por aqui os chamados de suporte abertos pelos vendedores'
          : 'Acompanhe por aqui o andamento dos chamados de suporte que você abriu'}
      </p>

      <div className="w-full border-b-[1px] bg-gray01" />

      <div className="mb-5 mt-6 flex flex-col-reverse items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="relative flex w-full items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="w-full rounded-lg pl-12 sm:w-96"
            placeholder="Pesquisar por número ou assunto"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
        </div>

        <div className="flex gap-2">
          {!isStaffView && <SupportRequestButton className="px-2" />}

          {isStaffView && (
            <Button
              className="h-auto rounded-lg py-2 text-white"
              onClick={() => claimNextSupportRequest()}
              disabled={isClaimingNext}
            >
              {isClaimingNext ? <Spinner /> : 'Atender próximo chamado'}
            </Button>
          )}
          <SupportRequestFilter
            statusOptions={statusOptions}
            selectedStatusOptions={selectedStatusOptions}
            onSelectStatus={handleSelectStatus}
            reasonOptions={reasonOptions}
            selectedReasonOptions={selectedReasonOptions}
            onSelectReason={handleSelectReason}
            onClearFilter={handleClearFilters}
          />
        </div>
      </div>

      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}

      {!isFetching && !isLoading && (
        supportRequests.length > 0 ? (
          <>

            <div className="block md:hidden">
              <MobileSupportRequestList
                supportRequests={supportRequests}
                isStaffView={isStaffView}
                onClick={(item) => openDetails(item.number || '-')}
                isFetchingNextPage={isFetchingNextPage}
              />
            </div>

            <div className="hidden md:block">
              <BasicTable<SupportRequest>
                type="table with lines"
                table={table}
                handleRowClick={(item) => openDetails(item.number || '-')}
                rowClassName={(item) =>
                  item.hasUnreadMessage ? '[&>td]:font-bold' : undefined
                }
                isFetchingNextPage={isFetchingNextPage}
              />
            </div>

            {shouldShowInfiniteScroll && !isFetchingNextPage && (
              <div ref={observerRef} className="h-1" />
            )}
          </>
        ) : (
          <div className="flex mt-20 justify-center">
            <p className="text-black04">Nenhum chamado encontrado</p>
          </div>
        )
      )}

      <SupportRequestDetailsSheet
        visible={isDetailsModalOpen}
        number={selectedNumber}
        onClose={closeDetails}
      />
    </div>
  )
}
